import { Component, OnInit, Input, ViewChild } from '@angular/core';
//import { StorageService } from '../../../../comum/services/storage.service';
import { DadosService } from '../../db/dados.service';
import { DownloadImgComponent } from '../download-Img';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import {MatDialog, MatDialogRef} from '@angular/material';
import {ProdutoDetailDialog} from "./produto-detail.dialog";
import { getTableNameFull } from '../../../../models/data.model';
import { VerMaisDialog } from '../ver-mais/ver-mais.dialog';

@Component({
  selector: 'forenecedor-control',
  templateUrl: './forenecedor.component.html',
  styleUrls: ['./forenecedor.component.css'],
})


export class ForenecedorComponent implements OnInit {
  loadedImg:boolean=false;
  item: any = {};
  favoritos = [];
  form: FormGroup;
  mostrarQtde:boolean=false;
  @Input() 
  index=-1;
  
  @Input()
  get value() {
    return this.item;
  }
  set value(v) {
    this.item = v;
  }

  qtde:number=1;
  constructor(
    public dialog: MatDialog,
    private dados: DadosService) {
    
      this.form = new FormGroup({
        qtde: new FormControl(),
      })


  }

  temReferencia()
  {
    let c = this.item.referenciasCount;
    return (c?c:0);
  }

  openDialog(x): void {
    let dialogRef = this.dialog.open(ProdutoDetailDialog, {
      maxWidth: "90%",
      minWidth: "70%",
      data:  x 
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result!=null){
        this.qtde = Number(result);
        if (this.qtde>0)
           this.addCarrinho();
      }
    });
  }

  ngOnInit() {
  }
  doImageChanged(){
    this.loadedImg = true;
  }

  isOdd() { 
    return this.index % 2;
  }

  alterarQtde(q){
    this.qtde = q;
    if (this.qtde<0) {
      this.qtde = 0;
    }
  }
  addCarrinho() {
    this.dados.addItem(this.item.fornecedor,
      this.item.codigo,
      this.qtde,
      this.item.precoVenda,this.item);

      this.qtde = 1;
  }

  getFavoritoKey() {
    return getTableNameFull('prodFavor<' + this.item.codigo + '>');
  }
  addFavorito() {
    let pf = this.getFavoritoKey();
    let f = Boolean(window.localStorage.getItem(pf));
    if (f == null) {
      f = true;
    } else
      f = !f;
    if (f) {
      window.localStorage.setItem(pf, String(f));
    } else
    window.localStorage.removeItem(pf);
    this.dados.setFavorito(this.item.codigo, (f ? 1 : -1));
  }
  isFavorito() {
    let rt = window.localStorage.getItem(this.getFavoritoKey());
    return rt;
  }

  getImagemProduto(item:any){
    if (item.img>""){
      return './img/F'+item.fornecedor+'/'+item.img;
    } else
      return './img/cc.png';
  }

  verMais(texto){
    let dialogRef = this.dialog.open(VerMaisDialog, {
      maxWidth: "90%",
      minWidth: "70%",
      data:  {title:"Informações do produto",text:texto}
    });


  }

  temMaisObs(texto){
    if (texto)
      return texto.length>50;
    else return false;
  }


}
